module.exports = __webpack_public_path__ + "static/img/2.1.4767fd3b.png";